// Import the functions you need from the SDKs you need
import firebase from "firebase";
var firebaseApp;

if (!firebase.apps.length) {
  firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDXDjOWwtDnfn01UCe-BgGL7u-zkvCferQ",
    authDomain: "musette-207b5.firebaseapp.com",
    projectId: "musette-207b5",
    storageBucket: "musette-207b5.appspot.com",
    messagingSenderId: "332339265291",
    appId: "1:332339265291:web:9293480da03d2393bdac0e",
    measurementId: "G-JKP1FNB1XT",
  });
} else {
  firebase.app(); // if already initialized, use that one
}

const db = firebase.app().firestore();
const auth = firebase.auth();
const storage = firebase.storage();

export { db, auth, storage };
